const colors = {
  primary: '#8cc63f',
  textHsla: 'hsla(0, 0%, 0%, 0.8)',
}

module.exports = { colors }
